"use strict";

console.log("acelightboxify!");

var $triggerElements = document.querySelectorAll('.acelightbox')

$triggerElements.forEach(function($triggerElement) {
	$triggerElement.addEventListener("click", function(e) {
		e.preventDefault();
		if (!this.getAttribute("data-acelightbox") && !this.getAttribute("href") && !this.getAttribute("src")) {
			console.log("Can't find an data-acelightbox, href, or src on this link. Cancelling lightbox.");
			return
		}


		var href = this.getAttribute("data-acelightbox") || this.getAttribute("href") || this.getAttribute("src");

		var allowZoom = !this.hasAttribute("data-acelightbox-no-zoom")
		console.log("allowZoom", allowZoom)

		var zoom = 1;
		var minZoom = 0.5;
		var maxZoom = 3;
		var zoomIncrement = 1.333;
		var dragging = false;
		var startDragX, startDragY, startImageX, startImageY;
		var w,h,r;
		
		
		var $othersInGroup;
		var $othersInGroupHrefs = []
		if (this.hasAttribute('data-acelightbox-group')) {
			var $othersInGroup = document.querySelectorAll('[data-acelightbox-group="'+this.getAttribute('data-acelightbox-group')+'"]')
			console.log("others in group", $othersInGroup)
			$othersInGroup.forEach(function($other) {
				$othersInGroupHrefs.push( $other.getAttribute("data-acelightbox") || $other.getAttribute("href") || $other.getAttribute("src") );
			})
			console.log("others in group hrefs", $othersInGroupHrefs)
		}

		var positionInGroup = 0;
		$othersInGroupHrefs.forEach(function($other, i) {
			if ($other == href) positionInGroup = i;
		})

		console.log("position in group", positionInGroup)


		// console.log("open LB");
		var $overlay = document.createElement('div');
		$overlay.classList.add('acelightbox_overlay')
		document.body.appendChild($overlay);

		var $container = document.createElement('div');
		$container.classList.add('acelightbox_container')
		document.body.appendChild($container);

		var $controls = document.createElement('div');
		$controls.classList.add('acelightbox_controls');
		if (allowZoom) {
			$controls.classList.add('acelightbox_controls_allow_zoom');
		}
		if ( $othersInGroup && $othersInGroup.length > 1) {
			$controls.classList.add('acelightbox_controls_in_group');
		}

		if ( $othersInGroup && $othersInGroup.length > 1) {
			$controls.innerHTML += "<a href='javascript:;' class='acelightbox_controls_left'></a>";
		}
		if (allowZoom) {
			$controls.innerHTML += "<a href='javascript:;' class='acelightbox_controls_minus'></a><a href='javascript:;' class='acelightbox_controls_plus'></a>";
		}
		$controls.innerHTML += "<a href='javascript:;' class='acelightbox_controls_close'></a>";
		if ( $othersInGroup && $othersInGroup.length > 1) {
			$controls.innerHTML += "<a href='javascript:;' class='acelightbox_controls_right'></a>";
		}
		// $controls.innerHTML += "<div style='clear: both;'>";
		$container.appendChild( $controls );

		
		var $img = document.createElement('img');
		$img.classList.add('acelightbox_image');
		$img.setAttribute('src', href);

		$img.addEventListener('load', function() {

			this.style.visibility = 'hidden';
			document.body.appendChild(this);
			this.style.width = 'auto';
			this.style.height = 'auto';
			w = this.offsetWidth;
			h = this.offsetHeight;
			this.style.display = 'none';

			r = w/h;
			// console.log("this: ", this);
			// console.log("w: ", w);
			// console.log("h: ", h);
			
			/*
			if (w > window.innerWidth*0.9) {
				w = window.innerWidth*0.9;
				h = w*(1/r);
				//console.log("too wide. reduced w to " + w + " h to " + h);
			}
			if (h > window.innerHeight*0.9) {
				h = window.innerHeight*0.9;
				w = h*r;
				//console.log("too tall. reduced w to " + w + " h to " + h);
			}
			*/

			$container.appendChild(this)
			this.style.display = 'block';
			this.style.visibility = 'visible';

			/*
			$content.style.width = w;
			$content.style.height = h;
			$content.style.marginLeft = -w/2;
			$content.style.marginTop = -h/2;
			*/
			
			$overlay.style.opacity = 0.5;
			$container.style.opacity = 1;

			$controls.addEventListener("click", function(event) {
				event.stopPropagation();
			})

			this.addEventListener("click", function(event) {
				event.stopPropagation();
			})
			
			var dragStart = function(event) {
				console.log("mousedown touchstart", event);
				event.preventDefault();
				event.stopPropagation();
				dragging = true;
				if (event.clientX) {
					startDragX = event.clientX;
					startDragY = event.clientY;
				} else if ( event.changedTouches && event.changedTouches[0] && event.changedTouches[0].clientX) {
					startDragX = event.changedTouches[0].clientX;
					startDragY = event.changedTouches[0].clientY;
				}
				startImageX = parseInt( this.style.marginLeft ? this.style.marginLeft : 0 );
				startImageY = parseInt( this.style.marginTop ? this.style.marginTop : 0 );
				
				console.log("dragStart", startDragX, startDragY, startImageX, startImageY);

			}
			this.addEventListener("mousedown", dragStart)
			this.addEventListener("touchstart", dragStart)

			window.addEventListener('mouseup', endDrag)
			window.addEventListener('touchend', endDrag)
			window.addEventListener('mousemove', doDrag)
			window.addEventListener('touchmove', doDrag)
			
			document.addEventListener("keyup", keyboardHandler);


			// prezoom two levels
			//zoom = 1*zoomIncrement*zoomIncrement;
			//changeZoom(true);
			
		})


		var endDrag = function() {
			dragging = false;
			console.log("mouseup");
		}

		var doDrag = function(event) {
			// console.log("doDrag (mousemove touchmove)", event);
			
			if (!dragging || zoom <= 1) return;
			var distanceX, distanceY;

			if (event.clientX) {
				distanceX = event.clientX - startDragX;
				distanceY = event.clientY - startDragY;
			} else if (event.changedTouches && event.changedTouches[0] && event.changedTouches[0].clientX) {
				distanceX = event.changedTouches[0].clientX - startDragX;
				distanceY = event.changedTouches[0].clientY - startDragY;
			}
			// console.log("doDrag", {startDragX, startDragY, startImageX, startImageY, distanceX, distanceY});

			$img.style.marginLeft = startImageX + distanceX + "px";
			$img.style.marginTop = startImageY + distanceY + "px";
		}

		var changeZoom = function() {
			console.log("zooming to " + zoom);
			if (zoom > 1) {
				$img.classList.add("zoomed")
			} else {
				$img.style.marginLeft = "0px";
				$img.style.marginTop = "0px";
				$img.classList.remove("zoomed")
			}
			$img.style.transform = "translate(-50%, -50%) scale("+zoom+")"
		}


		var closeLightbox = function(e) {
			if (e) e.preventDefault();
			console.log("closeLightbox", e);

			if (e.keyCode && e.keyCode != 27) {
				// it was a keyboard event, but not the ESCAPE key
				return false;
			} 

			window.removeEventListener("mouseup", endDrag);
			window.removeEventListener("mousemove", doDrag);
			document.removeEventListener("keyup", closeLightbox);

			document.body.removeChild( $overlay )
			document.body.removeChild( $container )
		}

		var keyboardHandler = function(e) {
			console.log("keyboardHandler");
			if (e.keyCode == 187 || e.keyCode == 107) {
				// +
				zoom *= zoomIncrement;
				if (zoom > maxZoom) zoom = maxZoom;
				changeZoom();
			} else if (e.keyCode == 189 || e.keyCode == 109) {
				// -
				zoom *= (1/zoomIncrement);
				if (zoom < 1) zoom = 1;
				changeZoom();
			}
		}

		if (allowZoom) {
			document.querySelector("a.acelightbox_controls_plus").addEventListener("click", function() {
				zoom *= zoomIncrement;
				if (zoom > maxZoom) zoom = maxZoom;
				changeZoom();
			})
			document.querySelector("a.acelightbox_controls_minus").addEventListener("click", function() {
				zoom *= (1/zoomIncrement);
				if (zoom < minZoom) zoom = minZoom;
				changeZoom();
			})
		}

		var prevImage = function() {
			positionInGroup--;
			if (positionInGroup < 0) positionInGroup = $othersInGroupHrefs.length - 1;
			$img.src = $othersInGroupHrefs[positionInGroup]
			zoom = 1;
			changeZoom();
		}
		
		var nextImage = function() {
			positionInGroup++;
			if (positionInGroup >= $othersInGroupHrefs.length) positionInGroup = 0;
			$img.src = $othersInGroupHrefs[positionInGroup]
			zoom = 1;
			changeZoom();
		}

		if (document.querySelector('.acelightbox_controls_left')) {
			document.querySelector('.acelightbox_controls_left').addEventListener('click', prevImage)
			document.querySelector('.acelightbox_controls_right').addEventListener('click', nextImage)
		}

		$overlay.addEventListener('click', closeLightbox)
		$container.addEventListener('click', closeLightbox)
		document.querySelector('a.acelightbox_controls_close').addEventListener('click', closeLightbox)


		document.addEventListener("keyup", closeLightbox)


		
	})

})